var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckWithConfetti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.989 34C121.517 34 119.5 32.0357 119.5 29.5381C119.5 27.06 121.517 25 123.989 25C126.464 25 128.5 27.06 128.5 29.5381C128.5 32.0357 126.464 34 123.989 34Z",
    fill: "#F9C977"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.495 126C129.396 126 128.5 125.127 128.5 124.017C128.5 122.916 129.396 122 130.495 122C131.595 122 132.5 122.916 132.5 124.017C132.5 125.127 131.595 126 130.495 126Z",
    fill: "#FB896E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.996 81C135.172 81 134.5 80.3452 134.5 79.5127C134.5 78.6867 135.172 78 135.996 78C136.821 78 137.5 78.6867 137.5 79.5127C137.5 80.3452 136.821 81 135.996 81Z",
    fill: "#42CFEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9942 71C12.6204 71 11.5 69.9087 11.5 68.5212C11.5 67.1444 12.6204 66 13.9942 66C15.3688 66 16.5 67.1444 16.5 68.5212C16.5 69.9087 15.3688 71 13.9942 71Z",
    fill: "#42CFEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.493 20C29.8445 20 28.5 18.6904 28.5 17.0254C28.5 15.3733 29.8445 14 31.493 14C33.1426 14 34.5 15.3733 34.5 17.0254C34.5 18.6904 33.1426 20 31.493 20Z",
    fill: "#ED69C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9918 125C36.0686 125 34.5 123.472 34.5 121.53C34.5 119.602 36.0686 118 37.9918 118C39.9164 118 41.5 119.602 41.5 121.53C41.5 123.472 39.9164 125 37.9918 125Z",
    fill: "#50E2DE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 77.5,
    r: 42.5,
    fill: "#42DCA440",
    stroke: "#42DCA480",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 77.5,
    r: 40.5,
    fill: "#42DCA4",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8533 89C73.0704 89 72.2875 88.6991 71.6899 88.0937L63.3964 79.6924C62.2012 78.4816 62.2012 76.5202 63.3964 75.3129C64.5917 74.1021 66.5244 74.0986 67.7197 75.3094L73.8533 81.5227L88.2803 66.9081C89.4756 65.6973 91.4083 65.6973 92.6035 66.9081C93.7988 68.1189 93.7988 70.0803 92.6035 71.2911L76.0166 88.0937C75.419 88.6991 74.6361 89 73.8533 89Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWithConfetti);
export default __webpack_public_path__ + "static/media/check-with-confetti.0e6db01ff92cf70cd5ff28d9eecd5ead.svg";
export { ForwardRef as ReactComponent };